import { render, staticRenderFns } from "./SidebarAdmin.vue?vue&type=template&id=63b8791b"
var script = {}
import style0 from "./SidebarAdmin.vue?vue&type=style&index=0&id=63b8791b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports